<!-- CP TEMPLATE -->
<div>
   
   <!-- Default Preview Wrapper -->
   <div class="preview-default-wrap"
      [class.link]="item.context === 'link' || item.context === 'applink'"
   >
      <div class="preview-wrap-icon-inner">
         
         <!-- Icon Display -->
         <sync-icon class="preview-icon" [name]="item.icon"></sync-icon>

         <!-- Non-openable File Message -->
         <div *ngIf="!item.previewonly && !upsell" class="preview-wrap-icon-inner-file-name h5">
            {{item.name}} - {{item.size | bytesToSize}}
            <div class="body-1">
               <ng-container *ngIf="notice > 0">
                  This file is too large to view<ng-container *ngIf="isOfficeDocument()"> and edit</ng-container>.
               </ng-container>
               <ng-container *ngIf="notice === 0">
                  View not available.
               </ng-container>
            </div>
         </div>

         <!-- Upgrade Notice for Non-Pro Users-->
         <div *ngIf="upsell" class="preview-default-content-wrapper">
            <div class="h5">Upgrade to view</div>
            <div class="body-1 preview-default-content">
              <span>
                Get built-in views for Microsoft Office, Photoshop and PDF files by upgrading your plan.
              </span>

              <!-- Additional Info for Office Documents -->
              <span *ngIf="isOfficeDocument()">
                <span>
                  <a class="syncblue" target="_blank" href="https://www.sync.com/help/microsoft-office-for-sync-getting-started-guide">Learn more</a>
                </span>
                <span> about how we work with Microsoft Office.</span>
              </span>
            </div>
            
            <!-- Notice for Large Office Documents and Non-Pro Users -->
            <ng-container *ngIf="notice > 0 && !user?.is_pro && isOfficeDocument()">
               <sync-divider></sync-divider>
               <span class="body-1">
                  This file is too large to view and edit.
               </span>
            </ng-container>
          </div>


         <!-- Action Buttons -->
         <div class="action-group">
            <!-- Edit/Open/Download Button Based on Conditions -->
            <sync-button 
                class="action-button" 
                *ngIf="openFileLabel && !isWhiteLabel" 
                [type]="type"
                [label]="openFileLabel"
                [leadAdornment]="true" 
                [leadIconAdornment]="leadIconAdornment"
                [onClick]="onClick">
            </sync-button>

            <!-- Download Button for Pro Users with Large PDF Files -->
            <sync-button 
                class="action-button"
                *ngIf="!item.previewonly && !isWhiteLabel && notice > 0 && user?.is_pro && isPDF()" 
                [type]="'filled'" 
                [label]="'Download'"
                [leadAdornment]="true" 
                leadIconAdornment="download" 
                [onClick]="downloadCompat">
            </sync-button>

            <!-- Upgrade Button for Non-Pro Users -->
            <app-upgrade-plan-button
               class="action-button"
               *ngIf="upsell && !isWhiteLabel"
               leadIcon="star-badge">
            </app-upgrade-plan-button>
         </div>
      </div>
   </div>
</div>
<!-- /CP TEMPLATE -->
